import ErroPedidoDTO from './erro-pedido.model';

export enum SituacaoSalvarPreCarga {
  VALIDANDO = 'VALIDANDO',
  GRAVANDO = 'GRAVANDO',
  AGUARDANDO_CONFIRMACAO = 'AGUARDANDO_CONFIRMACAO',
  ERRO = 'ERRO',
}

export enum TipoPendenciaSalvar {
  PEDIDOS_INVALIDOS = 'PEDIDOS_INVALIDOS',
  BONIFICADO_OBRIGATORIO = 'BONIFICADO_OBRIGATORIO',
  BONIFICADO_AVISO = 'BONIFICADO_AVISO',
}

/**
 * Impedimento encontrado nas validações executadas antes de enviar a gravação do carregamento
 */
export interface PendenciaSalvarPreCarga {
  tipo: TipoPendenciaSalvar;
  pedidosInvalidos?: ErroPedidoDTO[];
  mensagens?: string[];
}
